import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {GetDiscountsResponse_Discount} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {isExternalLink, useHistory} from '@aboutyou/router';
import {
  COLORS,
  DiscountToast,
  Z_INDEXES,
  useTimedOut,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {useGetGenderBanner} from '../../backend-services/Campaigns/hooks/useGetGenderBanner';
import {useCampaignOverlay} from './hooks/useCampaignOverlay';

export const CampaignOverlay = () => {
  const {shouldShow, discount} = useCampaignOverlay();
  const {t} = useTranslation();
  const getGenderBanner = useGetGenderBanner();
  const timedOut = useTimedOut(2000);
  const history = useHistory();
  const {isActive: isPriceDisplayOverhaulActive} = useIsFeatureActive(
    'price_display_overhaul',
  );

  if (!shouldShow) {
    return null;
  }

  const priceReduction = (discount as
    | GetDiscountsResponse_Discount
    | undefined)!;

  const genderTopBanner = getGenderBanner(discount!);

  const onClick = () => {
    if (discount?.linkTarget && isExternalLink(discount?.linkTarget.url)) {
      window.open(discount?.linkTarget.url, '_blank');
    } else if (discount?.linkTarget) {
      history.push(discount.linkTarget.url);
    }
  };

  const titleTranslation = isPriceDisplayOverhaulActive
    ? t('Don’t miss the DEAL')
    : t('Don’t miss the EXTRA SALE');

  return (
    <Wrapper>
      <PositionAbsolute>
        {/* Gate on timedOut so the card appears ~2s after mount; DiscountToast handles its own slide-in. */}
        {timedOut && (
          <DiscountToast
            title={t('Be quick!')}
            headline={titleTranslation}
            description={t('Grab your savings now!')}
            colors={{
              backgroundColor: genderTopBanner?.backgroundColor ?? '',
              foregroundColor: COLORS.White,
            }}
            countdown={
              genderTopBanner?.showCountdown
                ? {endsAt: priceReduction.campaign.period.endDate}
                : undefined
            }
            onClick={onClick}
            closeLabel={t('Close discount offer')}
          />
        )}
      </PositionAbsolute>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  z-index: ${Z_INDEXES.CAMPAIGN_OVERLAY};
`;

const PositionAbsolute = styled.div`
  position: absolute;
  width: 100%;
`;
